import {
  MembershipState,
  MembershipActionTypes,
  FETCH_MEMBERSHIPS_REQUEST,
  FETCH_MEMBERSHIPS_SUCCESS,
  FETCH_MEMBERSHIPS_FAILURE,
  SET_MEMBERSHIPS_LOADED,
  PATCH_MEMBERSHIP_ADMIN_STATUS_REQUEST,
  PATCH_MEMBERSHIP_ADMIN_STATUS_SUCCESS,
  PATCH_MEMBERSHIP_ADMIN_STATUS_FAILURE,
} from "./types";

// Initial state for membership reducer
const initialMembershipState: MembershipState = {
  memberships: [],
  memberShipsLoaded: false,
  isLoading: false,
  error: null,
};

/**
 * Reducer function for managing the state related to organization memberships.
 * @param state - Current state of organization memberships.
 * @param action - Action dispatched to update the state.
 * @returns Updated state based on the action type.
 */
const membershipReducer = (
  state = initialMembershipState,
  action: MembershipActionTypes
): MembershipState => {
  switch (action.type) {
    case FETCH_MEMBERSHIPS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_MEMBERSHIPS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        memberships: action.payload,
        error: null,
      };
    case FETCH_MEMBERSHIPS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case SET_MEMBERSHIPS_LOADED:
      return {
        ...state,
        memberShipsLoaded: true,
        isLoading: false,
      };
    case PATCH_MEMBERSHIP_ADMIN_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case PATCH_MEMBERSHIP_ADMIN_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        memberships: state.memberships.map((membership) =>
          membership.id === action.membershipId
            ? { ...membership, isAdmin: true }
            : membership
        ),
        error: null,
      };
    case PATCH_MEMBERSHIP_ADMIN_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export { membershipReducer};
